<section>
  <div class="sx-dialog__scroll-area">
  <button class="sx-button sx-button--white sx-button--exit" mat-button (click)="onCancel()">
    <svg>
      <use xlink:href="#baseline-close-24px" href="#baseline-close-24px" />
    </svg>
  </button>

  <header class="sx-dialog__content">
    <h2 class="sx-dialog__heading h3"> {{ meteringPoint.name }} </h2>
    <div>{{'meteringpoints.info.id' | translate}} {{ meteringPoint.id }} </div>
  </header>

  <div class="sx-dialog__sectioner sxl-space-between">
    <span>{{'meteringpoints.info.property_data_label' | translate}}</span>
  </div>

  <div class="sx-dialog__content">

    <div *ngIf="disruptionInfo" class="sx-dialog-metering-info__data-row">
      <div class="sx-dialog-metering-info__data-title">{{'meteringpoints.info.disruption_label' | translate}}</div>
      <div *ngIf="!disruptionInfo.estimatedRestoreTime">{{'disruptions.no_restore_information_label' |
        translate}}</div>
      <div *ngIf="disruptionInfo.estimatedRestoreTime">{{'disruptions.restore_information_label' |
        translate}} {{disruptionInfo.estimatedRestoreTime | date: 'HH:mm, d MMMM yyyy'}}</div>
    </div>


    <div class="sx-dialog-metering-info__data-row">
      <div class="sx-dialog-metering-info__data-title">{{'meteringpoints.info.customer_label' | translate}}</div>
      <div>{{ customerName }}</div>
    </div>

    <div class="sx-dialog-metering-info__data-row">
      <div class="sx-dialog-metering-info__data-title">{{'meteringpoints.info.address_label' | translate}}</div>
      <div>{{ meteringPoint.addresses && meteringPoint.addresses.length > 0 ?
        prettyPrintAddress(meteringPoint.addresses[0])
        : ''}}</div>
    </div>

    <div class="sx-dialog-metering-info__data-row">
      <div class="sx-dialog-metering-info__data-title">{{'meteringpoints.info.category_label' | translate}}</div>
      <div>{{ meteringPoint.category }}</div>
    </div>

    <div class="sx-dialog-metering-info__data-row">
      <div class="sx-dialog-metering-info__data-title">{{'meteringpoints.info.area_label' | translate}}</div>
      <div>{{ meteringPoint.area }} m
        <sup class="sx-dialog-metering-info--sup">2</sup>
      </div>
    </div>

    <div class="sx-dialog-metering-info__data-row sx-dialog-metering-info__report-container">
      <svg class="sxh-icon-big">
        <use xlink:href="#sx-pdf" href="#sx-pdf" />
      </svg>
      <a class="sx-dialog-metering-info__report-link" href="javascript:void(0);" (click)="getReport(meteringPoint.id)">{{(meteringPoint.meteringType === 'Hot' ? 'meteringpoints.info.hot_report_label' : 'meteringpoints.info.cold_report_label')
        | translate}}
        </a>
    </div>
  </div>

  <div *ngIf="isLogical && meteringPoint ">
    <div class="sx-dialog__sectioner sx-dialog__sectioner--purple sxl-space-between">
      <span>{{'meteringpoints.info.logic_label' | translate}}</span>
    </div>
    <div class="sx-dialog__content">
      <div class="sx-dialog-metering-info__data-row" *ngFor="let child of meteringPoint.containedMeteringPoints">
        <div class="sx-dialog-metering-info__data-row--big">{{ child.name }}</div>
        <div>{{ meteringPoint.addresses && meteringPoint.addresses.length > 0 ? prettyPrintAddress(child.addresses[0])
          :
          ''}}</div>
      </div>
    </div>
  </div>

  <app-function-control-listing [meteringPoint]="meteringPoint" ></app-function-control-listing>
  </div>

</section>
